<template>
  <div>
    <div class="portal-case-card-for-home">
      <header>
        <a :href="moreHref" target="_blank"
          ><img :src="card.img" :alt="card.name"
        /></a>
        <label>{{ card.name }}</label>
      </header>
      <div class="list-wrap">
        <ul>
          <li v-for="item of caseList" :key="item.id">
            <a target="_blank" :href="item.href">{{ item.title }}</a>
          </li>
        </ul>
      </div>
      <div class="more">
        <a :href="moreHref" target="_blank">
          <span>查看更多</span>
          <i></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { host } from "src/config";
import { qryCase } from "../../request/portal";

export default {
  name: "PortalCaseCardForHome",
  props: {
    env: {
      type: String,
      default: "local",
    },
    /* 执行的系统，portal member */
    system: {
      type: String,
      default: "portal",
    },
    /* 单条数据源 */
    cardData: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      host: host(this.env),
      card: this.cardData,
      caseList: [],
      moreHref: "",
    };
  },
  methods: {},
  mounted() {
    const params = {
      pageRow: "5",
      pageNum: "1",
      qryNum: 5,
    };
    params.alias = !this.card.notAlias ? this.card.alias : '';
    params.notAlias = this.card.notAlias;
    qryCase(params, this.host.nodeUrl).then((res) => {
      if (res && res.data && res.data.items) {
        if (window.location.host.includes("member")) {
          this.moreHref = !this.card.notAlias
            ? this.host.sgsonlineUrl +
              "/information?type=" +
              res.data.items[0].catalogId
            : this.host.sgsonlineUrl + "/information";
        } else {
          this.moreHref = !this.card.notAlias
            ? "/information?type=" + res.data.items[0].catalogId
            : "/information";
        }
        res.data.items.forEach((v) => {
          if (window.location.host.includes("member")) {
            v.href =
              this.host.sgsonlineUrl +
              "/case/" +
              v.alias +
              "/detail-" +
              v.id +
              ".html";
          } else {
            v.href =
              "/case/" +
              v.alias +
              "/detail-" +
              v.id +
              ".html?catalogCode=" +
              v.catalogCode;
          }
        });
        this.caseList = res.data.items;
      }
    });
  },
};
</script>

<style lang="scss">
@import "./../../assets/style/mixin.scss";

.portal-case-card-for-home {
  width: 380px;
  height: 408px;
  box-sizing: border-box;
  background: #fff;
  padding: 20px;

  header {
    width: 342px;
    height: 116px;
    background: #f5f5f5;
    position: relative;

    img {
      width: 342px;
      height: 116px;
    }
    label {
      height: 29px;
      line-height: 29px;
      padding: 0 12px;
      color: #fff;
      font-size: 12px;
      background: $mainColor;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 0px 0px 12px 0px;
    }
  }

  .list-wrap {
    ul,
    li {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    ul {
      margin-top: 15px;
    }
    li {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px dotted #d9d9d9;
    }
    a {
      color: #333;
      font-size: 14px;
      width: 340px;
      height: 40px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;

      &:hover {
        color: $mainColor;
      }
    }
  }
  .more {
    padding: 18px 0 0 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;

    &:hover {
      span {
        color: $mainColor;
      }
      i {
        background: url("../../assets/images/portal/case/more-active.png");
      }
    }
    span {
      font-size: 14px;
      margin-right: 10px;
      color: #878787;
    }
    i {
      display: inline-block;
      width: 14px;
      height: 9px;
      background: url("../../assets/images/portal/case/more.png");
    }
  }
}
</style>
